module.exports = __webpack_public_path__ + "static/media/location.8a704528.svg";